import React, { useMemo } from 'react'
import { Link as _Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'


const Link = (props) => {
  const location = useLocation()
  const _props = Object.assign({}, props)
  const state = Object.assign({}, location.state, {dirty: true})
  if (typeof props.to === 'string') {
    _props.to = {pathname:props.to, state: state}
  } else {
    _props.to = Object.assign({state: state}, props.to)
  }
  return useMemo(
    () => <_Link {..._props} />, 
    [_props]
  )
}


export default Link
